export default __webpack_public_path__ + "static/media/admin-feature.2f909d37.svg";